import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/App.css";
import { AuthContext } from "../contexts/AuthContext";
import { jwtDecode } from 'jwt-decode';
import { APIBaseLink } from "../components/APIBaseLink";

function VerifyAccountPage() {
	const { token } = useParams();
	const [message, setMessage] = useState("");
	const [error, setError] = useState("");
	const navigate = useNavigate();

	const API_BASE_LINK = APIBaseLink();

	// Purpose: To change account status when a user navgiates here from the given link
	// Input: User enters page via given link
	// Output: User account/email is verified and the stored account status is updated
	// ToDo: do useEffect to call verifyAccount call when created, then show account is verified, then naviate to login after a delay.
	useEffect(() => {
		const verifyAccount = async () => {
			try {
				const data = jwtDecode(token);
				console.log(data);
				const response = await fetch(`${API_BASE_LINK}/user/verifyAccount/${data.id}`, {
					method: "POST",
					headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
				});

				if (response.ok) {
					setMessage("Your account has been verified successfully");
					// Redirect to login after a short delay
					setTimeout(() => {
						navigate("/login");
					}, 3000);
				} else {
					const contentType = response.headers.get("content-type");
					let res;
					if (contentType && contentType.indexOf("application/json") !== -1) {
						res = await response.json();
					} else {
						res = { message: "Error verifying account" };
					}
					setError(res.message || "Error verifying account");
				}
			} catch (err) {
				console.log("Error:", err);
				setError(err.message || "An error occurred while verifying your account.");
			}
		};

		verifyAccount();
	});

	return (
		<div className="form-page">
			{message && !error ? (
				<div>
					<h2>{message}</h2>
					<h3>Redirecting you to the login page...</h3>
				</div>
			) : error ? (
				<div>
					<h2>{error}</h2>
					<h3>Please try again later.</h3>
				</div>
			) : (
				<div>
					<h2>Your account is being verifed</h2>
					<h3>Please wait...</h3>
				</div>
			)}
		</div>
	);
}

export default VerifyAccountPage;
